import React from 'react'
import PropTypes from 'prop-types'

import Dollars from '../../Dollars/Dollars'
import FieldsetDropDown from '../../../assets/fieldset-drop-down.svg'

import './ModifierFieldLabel.css'

export const ModifierFieldLabel = ({ name, price, hasNested, outOfStock = false, nestedModifiersNames = [] }) => {
  const hasPrice = Boolean(price)

  const aside = outOfStock
    ? (
      <span data-testid='modifiers-details' styleName='modifierDetails outOfStock'>
        -Out of stock-
      </span>
    )
    : (hasPrice || hasNested) && (
      <span data-testid='modifiers-details' styleName='modifierDetails'>
        {hasPrice && <span data-testid='modifiers-price' styleName='modifierPrice'><Dollars showLeadingSign amount={price} /></span>}
        {hasNested && <span data-testid='modifiers-has-nested-indicator' styleName='modifierMore'><FieldsetDropDown /></span>}
      </span>
    )
  return (
    <span styleName='modifier'>
      <div styleName='modifierDescription'>
        <div>{name}</div>
        {nestedModifiersNames.length > 0 && <div data-testid='modifiers-nested-selections' styleName='nestedSelections'>{nestedModifiersNames.join(', ')}</div>}
      </div>
      {aside}
    </span>
  )
}

ModifierFieldLabel.propTypes = {
  name: PropTypes.string.isRequired,
  price: PropTypes.number,
  hasNested: PropTypes.bool,
  outOfStock: PropTypes.bool,
  nestedModifiersNames: PropTypes.array.isRequired
}
